import { Component, EventEmitter, Input, Output, OnInit, OnChanges, SimpleChanges } from '@angular/core';

import { representanteSituacoes } from '../representante-situacao';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';

@Component({
    selector: 'sgt-representante-situacao-multiselect',
    templateUrl: './representante-situacao-multiselect.component.html',
    styleUrls: ['./representante-situacao-multiselect.component.less']
})
export class RepresentanteSituacaoMultiselectComponent implements OnInit, OnChanges {
    /** Situações dos representantes selecionados */
    @Input() situacoes: number[];
    /** Ao alterar a seleção das situações dos representantes */
    @Output() situacoesChange = new EventEmitter<number[]>();

    /** Cadastro de representantes para filtrar as situações */
    @Input() cadastros: number[] = [];

    /** Se deve exibir a opção para filtrar os representante que somente possui clientes */
    @Input() showSomenteComClientes = false;
    @Input() somenteComClientes = false;
    @Output() somenteComClientesChange = new EventEmitter<boolean>();

    // Settings
    settings: IMultiSelectSettings;
    @Input() pullRight = false;
    @Input() enableSearch = true;
    @Input() showCheckAll = true;
    @Input() showUncheckAll = true;
    @Input() dynamicTitleMaxItems = 0;
    @Input() fixedTitle = false;
    /** Se deve exibir o multiselect acima */
    @Input() dropup = false;
    /** Se deve desabilitar o multiselect */
    @Input() disabled = false;

    // Texts
    texts: IMultiSelectTexts;
    @Input() checkAll = 'Selecionar Todos';
    @Input() uncheckAll = 'Limpar';
    @Input() defaultTitle = 'Nenhuma Situação';
    @Input() checked = 'Situação';
    @Input() checkedPlural = 'Situações';
    @Input() searchPlaceholder = 'Pesquisar...';
    @Input() allSelected = 'Todos Selecionados';
    @Input() searchEmptyResult = 'Nenhuma situação encontrada';
    @Input() searchNoRenderText = 'Digite para pesquisar';

    // Options
    options: IMultiSelectOption[];

    ngOnInit() {
        // Settings
        this.settings = {
            pullRight: this.pullRight,
            enableSearch: this.enableSearch,
            containerClasses: `container-multiselect container-multiselect-representante-situacao ${this.dropup ? 'dropup' : 'dropdown'}`,
            showCheckAll: this.showCheckAll,
            showUncheckAll: this.showUncheckAll,
            dynamicTitleMaxItems: this.dynamicTitleMaxItems,
            fixedTitle: this.fixedTitle
        };
        // Texts
        this.texts = {
            checkAll: this.checkAll,
            uncheckAll: this.uncheckAll,
            defaultTitle: this.defaultTitle,
            checked: this.checked,
            checkedPlural: this.checkedPlural,
            searchPlaceholder: this.searchPlaceholder,
            allSelected: this.allSelected,
            searchEmptyResult: this.searchEmptyResult,
            searchNoRenderText: this.searchNoRenderText
        };

        this.create();
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            // Ao alterar os cadastros para os filtros das situações, recriamos as opções do multiselect
            if (propName === 'cadastros' && !changes[propName].isFirstChange()) {
                this.create();
            }
        }
    }

    /** Cria as situações dos representantes para o multiselect */
    private create() {
        this.options = [];
        const selects: IMultiSelectOption[] = [];

        // Situações
        representanteSituacoes.forEach(situacao => {
            selects.push({
                id: situacao.id,
                name: situacao.nome,
            });
        });

        // Somente com clientes
        if (this.showSomenteComClientes) {
            selects.push({
                id: 0,
                name: 'Somente com Clientes'
            });
        }

        this.options = selects;
    }

    /** Ao alterar a seleção da opção de somente com clientes */
    private onChangeSomenteComClientes() {
        this.somenteComClientes = this.situacoes.includes(0);
        this.somenteComClientesChange.emit(this.somenteComClientes);
    }

    /** Ao alterar a seleção das situações dos representantes */
    onChange() {
        this.onChangeSomenteComClientes();
        this.situacoesChange.emit(this.situacoes);
    }
}
